<template>
  <div class="row pricing-table-four">
    <div
      class="
        col-12 col-md-6 col-lg-6 col-xl-4
        pricing-table pricing-table--popular
        wow
        move-up
      "
    >
      <div class="pricing-table__inner">
        <div class="pricing-table__top">
          <div class="pricing-table__header">
            <div class="pricing-table__image">
              <img
                src="../assets/img/pricing/aeroland-pricing-05-image-01.png"
                class="img-fluid"
                alt=""
              />
            </div>
            <h5 class="pricing-table__title">Peronal</h5>
          </div>
          <div class="pricing-table__body">
            <ul
              class="check-list green-check-list pricing-table__list text-left"
            >
              <li class="list-item">Completely FREE and always will be</li>
              <li class="list-item">
                Software is provided as is and ready to use
              </li>
              <li class="list-item">
                Standard support for setting up and running
              </li>
              <li class="list-item">
                Crucial modules available: PAS, EMR, HRM
              </li>
            </ul>
          </div>
        </div>
        <div class="pricing-table__footer">
          <button
            @click="signupApp"
            type="submit"
            class="ht-btn ht-btn-lg"
            style="
            color: white;
            border-color: white;
            border-width: 2px;
            width: 240px;
            line-height: 56px;
          "
          >
            Create Account
          </button>
        </div>
      </div>
    </div>
    <div
      class="
        col-12 col-md-6 col-lg-6 col-xl-4
        pricing-table pricing-table--popular
        wow
        move-up
      "
    >
      <div class="pricing-table__inner">
        <div class="pricing-table__top">
          <div class="pricing-table__header">
            <div class="pricing-table__image">
              <img
                src="../assets/img/pricing/aeroland-pricing-05-image-02.png"
                class="img-fluid"
                alt=""
              />
            </div>
            <h5 class="pricing-table__title">Clinic</h5>
          </div>
          <div class="pricing-table__body">
            <ul
              class="check-list green-check-list pricing-table__list text-left"
            >
              <li class="list-item">From $1,000 Annually</li>
              <li class="list-item">Include Everything in Peronsal package</li>
              <li class="list-item">
                Complete support for setting up and medical form implementation
              </li>
              <li class="list-item">
                Applicable to new modules: Query Builder, Data Manager
              </li>
            </ul>
          </div>
        </div>
        <div class="pricing-table__footer">
          <button
            @click="signupApp"
            type="submit"
            class="ht-btn ht-btn-lg"
            style="
            color: white;
            border-color: white;
            border-width: 2px;
            width: 240px;
            line-height: 56px;
          "
          >
            Create Account
          </button>
        </div>
      </div>
    </div>
    <div
      class="
        col-12 col-md-6 col-lg-6 col-xl-4
        pricing-table pricing-table--popular
        wow
        move-up
      "
    >
      <div class="pricing-table__inner">
        <div class="pricing-table__top">
          <div class="pricing-table__header">
            <div class="pricing-table__image">
              <img
                src="../assets/img/pricing/aeroland-pricing-05-image-02.png"
                class="img-fluid"
                alt=""
              />
            </div>
            <h5 class="pricing-table__title">Hospital</h5>
          </div>
          <div class="pricing-table__body">
            <ul
              class="check-list green-check-list pricing-table__list text-left"
            >
              <li class="list-item">Flexible pricing plan</li>
              <li class="list-item">Include Everything in Clinic package</li>
              <li class="list-item">
                Prefessional support for scaling the platform into existing
                infrastructure
              </li>
              <li class="list-item">
                On-demand development of AI Diagnosis modules
              </li>
            </ul>
          </div>
        </div>
        <div class="pricing-table__footer">
          <button
            @click="bookMeeting"
            type="submit"
            class="ht-btn ht-btn-lg"
            style="
            color: white;
            border-color: white;
            border-width: 2px;
            width: 240px;
            line-height: 56px;
          "
          >
            Book Appointment
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "pricingFour",
  methods: {
    signupApp() {
      window.open("https://his.sandrasoft.app/signup");
    },
    bookMeeting() {
      window.open("https://calendly.com/nichealpham/experiment1et");
    },
  },
};
</script>
<style scoped>
.check-list.green-check-list .list-item::before {
  color: #38cb89;
  font-size: 1rem;
  line-height: 2rem;
}
.pricing-table-one .pricing-table__list li,
.pricing-table-four .pricing-table__list li {
  padding: 5px 0 0 1.8rem;
}
</style>
